<template>
    <div>
        <b-card-actions action-collapse title="Manage Property Group">
            <validation-observer ref="SubscriberRules" v-slot="{ validate }">
                <b-form @submit.prevent="onSubmit(validate)">
                <b-row>
                    <b-col cols="12" md="6" class="mb-md-0 mb-2">
                    <b-form-group label="Title">
                        <validation-provider
                        name="title"
                        rules="required"
                        v-slot="{ errors }"
                        >
                        <b-form-input
                            v-model="title"
                            placeholder="Enter title"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                    </b-col>

                    <b-col cols="12">
                    <b-button
                        variant="primary"
                        type="submit"
                    >
                        Submit
                    </b-button>
                    </b-col>
                </b-row>
                </b-form>
            </validation-observer>
        </b-card-actions>

        <b-card-actions action-collapse title="Property Selected">
            <b-row class="mb-1">
                <!-- <b-col md="12">
                    <b-button
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        @click="formmail_show"
                        variant="outline-primary"
                    >
                        Generator Email
                    </b-button>
                </b-col> -->
                <div class="table-selected table-responsive">
                    <table class="table b-table table-striped table-hover">
                        <thead>
                            <th></th>
                            <th></th>
                            <th>IMAGE</th>
                            <th>PROPERTY CODE</th>
                            <th>Owner</th>
                            <th>UNITS</th>
                            <th>FLOOR</th>
                            <th>TYPE</th>
                            <th>Close Deal</th>
                            <th>BUILDING</th>
                            <th>BD</th>
                            <th>SQM</th>
                            <th>RENT</th>
                            <th>SALE</th>
                            <th>EXP/AVAIL DATE</th>
                            <th>RATING</th>
                            <th>FURNITURE</th>
                            <th>BTS</th>
                            <th>MRT</th>
                            <th>ZONE</th>
                        </thead>
                        <draggable v-model="selectedProperties" tag="tbody"  handle=".handle">
                            <tr v-for="item in selectedProperties" :key="item.name">
                                <td scope="row" style="padding-left:10px;">
                                    <feather-icon @click="removeProperty(item.id)" icon="MinusIcon" />
                                </td>
                                <td> 
                                    <feather-icon   class="handle size-25  mr-3" style="font-size:20px;" icon="MenuIcon" />
                                </td>
                                <td>
                                    <b-img 
                                        class="img_property" 
                                        v-if="item.property_images[0] "
                                        :src="item.property_images[0].fullfilepath"
                                    />
                                    <b-img   
                                        class="img_property" v-else
                                        :src="'http://128.199.95.64:81/assets/images/default/property/picture.png'"
                                    />
                                </td>
                                <td>
                                    <div class="list-property">
                                        <router-link :to="{ name: 'property-edit', params: { id: item.id } }" >{{ item.property_code }}</router-link>
                                        <b-badge v-if="item.action_id == 1" variant="light-secondary">
                                            {{ item.action_name }}
                                        </b-badge>
                                        <b-badge v-if="item.action_id == 2" variant="light-info">
                                            {{ item.action_name }}
                                        </b-badge>
                                        <b-badge v-if="item.action_id == 3" variant="light-success">
                                            {{ item.action_name }}
                                        </b-badge>
                                        <b-badge v-if="item.action_id == 4" variant="light-warning">
                                            {{ item.action_name }}
                                        </b-badge>
                                        <b-badge v-if="item.status_id == 1" variant="light-success">
                                            {{ item.status_code }}
                                        </b-badge>
                                        <b-badge v-else variant="light-secondary">
                                            {{ item.status_code }}
                                        </b-badge>
                                        <b-badge  variant="light-primary"   @click="doCopy(item.place_name,item.property_code)">
                                            <feather-icon
                                                icon="CopyIcon"
                                                size="24"
                                            />
                                        </b-badge>
                                        <br />
                                        {{ item.place_name[currentLocale] }}
                                        <br />
                                        <br />
                                    </div>
                                </td>
                                <td>
                                    <span class="vs-label"><router-link :to="{ name: 'clients-edit', params: { id: item.owner_id } }"  target="_blank">{{ item.owner_firstname  }} {{ item.owner_lastname  }}</router-link></span><br />
                                    <strong>Email : </strong> <a :href="'mailto:'+item.owner_email">{{ item.owner_email  }} </a><br />
                                    <strong>Phone : </strong><a :href="'tel:'+item.owner_phone">{{ item.owner_phone  }} </a>
                                </td>
                                <td>
                                    {{ item.units }} 
                                    {{ item.address_no }}
                                </td>
                                <td>{{ item.floors }}</td>
                                <td>{{ item.type_name }}</td>
                                <td>
                                    <b-button variant="flat-primary" class="pb0" :to="{ name: 'close-deal-create', params: { id: id, property_id:item.id } }">
                                        close
                                    </b-button>
                                </td>
                                <td>{{ item.buildiing }}</td>
                                <td>{{ item.bedroom }}</td>
                                <td>{{ item.sqm }}</td>
                                <td> {{ item.rent_price | getcomma }}</td>
                                <td>{{ item.sale_price | getcomma }}</td>
                                <td>{{ item.exp }}</td>
                                <td>{{ item.rating }}</td>
                                <td>{{ item.furniture_name }}</td>
                                <td>{{ item.bts_name }}</td>
                                <td>{{ item.mrt_name }}</td>
                                <td>{{ item.zone_name }}</td>
                            </tr>
                        
                        </draggable>
                    </table>
                </div>
            </b-row>
        </b-card-actions>

        <b-card-actions action-collapse title="Property List">
            <b-table
                striped
                hover
                responsive
                :items="propertyList"
                :fields="fields_properties"
                show-empty
                empty-text="No matching records found"
            >
                <template slot="top-row" slot-scope="{ fields }">
                    <td v-for="field in fields" :key="field.key">
                        <b-form-input
                            v-if="field.key == 'units'"
                            v-model="unit"
                            :placeholder="field.label"
                        />
                        <b-form-input
                            v-if="field.key == 'floors'"
                            v-model="floor"
                            :placeholder="field.label"
                        />
                        <b-form-input
                            v-if="field.key == 'types'"
                            v-model="types"
                            :placeholder="field.label"
                        />
                        <b-form-input
                            v-if="field.key == 'buildiing'"
                            v-model="building"
                            :placeholder="field.label"
                        />
                        <b-form-input
                            v-if="field.key == 'bedroom'"
                            v-model="bedroom"
                            :placeholder="field.label"
                        />
                        <b-form-input
                            v-if="field.key == 'sqm'"
                            v-model="sqm"
                            :placeholder="field.label"
                        />
                        <b-form-input
                            v-if="field.key == 'price_rent'"
                            v-model="price_rent"
                            :placeholder="field.label"
                        />
                        <b-form-input
                            v-if="field.key == 'price_sale'"
                            v-model="price_sale"
                            :placeholder="field.label"
                        />
                        <b-form-input
                            v-if="field.key == 'property'"
                            v-model="propertyfilter"
                            :placeholder="field.label"
                        />
                        <b-form-input
                            v-if="field.key == 'owner'"
                            v-model="ownerfilter"
                            :placeholder="field.label"
                        />
                    </td>
                </template>
                <template #cell(id)="data">
                    <feather-icon @click="addProperty(data.item)" icon="PlusIcon" />
                </template>
                <template #cell(units)="data">
                    {{ data.item.units }} 
                    {{ data.item.address_no }}
                </template>
                <template #cell(property)="data">
                    <div class="list-property">
                        <router-link :to="{ name: 'property-edit', params: { id: data.item.id } }" >{{ data.item.property_code }}</router-link>
                        <b-badge v-if="data.item.action_id == 1" variant="light-secondary">
                            {{ data.item.action_name }}
                        </b-badge>
                        <b-badge v-if="data.item.action_id == 2" variant="light-info">
                            {{ data.item.action_name }}
                        </b-badge>
                        <b-badge v-if="data.item.action_id == 3" variant="light-success">
                            {{ data.item.action_name }}
                        </b-badge>
                        <b-badge v-if="data.item.action_id == 4" variant="light-warning">
                            {{ data.item.action_name }}
                        </b-badge>
                        <b-badge v-if="data.item.status_id == 1" variant="light-success">
                            {{ data.item.status_code }}
                        </b-badge>
                        <b-badge v-else variant="light-secondary">
                            {{ data.item.status_code }}
                        </b-badge>
                        <br />
                        {{ data.item.place_name[currentLocale] }}
                        <br />
                        <br />
                        {{ data.item.comment }}
                    </div>
                </template>
                <template #cell(image)="data">
                    <b-button variant="flat-primary" class="pb0" :to="{ name: 'property-upload', params: { id: data.item.id } }">
                        <b-img   
                            class="img_property" 
                            v-if="data.item.property_images[0]"
                            :src="data.item.property_images[0].fullfilepath"  
                        />
                        <b-img   
                            class="img_property" v-else
                            :src="'http://128.199.95.64:81/assets/images/default/property/picture.png'"     
                        />
                    </b-button>  
                </template>
                <template #cell(owner)="row">
                    <b-form-checkbox
                        v-model="row.detailsShowing"
                        plain
                        class="vs-checkbox-con"
                        @change="row.toggleDetails"
                    >
                        <span class="vs-label">{{ row.item.owner_firstname  }} {{ row.item.owner_lastname  }}</span><br />
                    </b-form-checkbox>
                </template>
                <template #row-details="row">
                    <b-card>
                        <b-row class="mb-2">
                            <b-col md="4" class="mb-1" >
                                <strong>Full Name : </strong><router-link :to="{ name: 'clients-edit', params: { id: row.item.owner_id } }"  target="_blank">{{ row.item.owner_firstname  }} {{ row.item.owner_lastname  }}</router-link>
                            </b-col>
                            <b-col md="4" class="mb-1" >
                                <strong>Email : </strong> <a :href="'mailto:'+row.item.owner_email">{{ row.item.owner_email  }} </a>
                            </b-col>
                            <b-col md="4" class="mb-1" >
                                <strong>Phone : </strong><a :href="'tel:'+row.item.owner_phone">{{ row.item.owner_phone  }} </a>
                            </b-col>
                        </b-row>
                        <b-button
                            size="sm"
                            variant="outline-secondary"
                            @click="row.toggleDetails"
                        >
                            Hide Details
                        </b-button>
                    </b-card>
                </template>
                <template #cell(price_rent)="data">
                    {{ data.item.rent_price | getcomma }}
                </template>
                <template #cell(price_sale)="data">
                    {{ data.item.sale_price | getcomma }}
                </template>
            </b-table>
        </b-card-actions>
    </div>
</template>

<script>
import { ref, onUnmounted } from '@vue/composition-api'
import {
  BCard, BRow, BCol, BFormGroup, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BForm,
  BBadge, BDropdown, BDropdownItem, BPagination,BFormCheckbox,BImg,BCardHeader,BCardBody,BOverlay
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import BCardActions from '../../../@core/components/b-card-actions/BCardActions.vue'
import Button from '../../components/button/Button.vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  required, email, confirmed, url, between, alpha, integer, password, min, digits, alphaDash, length,
} from '@validations';
import store from '@/store';
import axios from '@axios';
import router from '@/router'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import crmStoreModule from '../crmStoreModule';
import draggable from 'vuedraggable'

export default {
    components:{
        ValidationProvider, 
        ValidationObserver,
        crmStoreModule,
        BCard, BRow, BCol, BFormGroup , BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
        BBadge, BDropdown, BDropdownItem, BPagination, BFormCheckbox, BImg,
        vSelect,
        BCardHeader, BCardBody, BOverlay,
        BCardActions,
        Button,
        BForm,
        draggable,
    },
    data() {
        return {
            id: router?.currentRoute?.params?.id,
            title: '',
            selectedProperties: [],
            selectedProperttIds: [],
            fields_properties:[
                {
                    key: 'id', label: '',
                },
            
                {
                    key: 'image', label: 'Image', tdClass:'width-300 p-0',
                },
                {
                    key: 'property', label: 'Property Code',
                },
                {
                    key: 'owner', label: 'Owner',
                },
                {
                    key: 'units', label: 'units',
                },
                {
                    key: 'floors', label: 'Floor',
                },
                {
                    key: 'type_name', label: 'Type',
                },
                {
                    key: 'buildiing', label: 'Building',
                },
                {
                    key: 'bedroom', label: 'Bd',
                },
                {
                    key: 'sqm', label: 'Sqm',
                },
                {
                    key: 'price_rent', label: 'Rent',
                },
                {
                    key: 'price_sale', label: 'Sale',
                },
                {
                    key: 'exp', label: 'Exp/Avail Date  ',
                },
                {
                    key: 'rating', label: 'Rating',
                },
                {
                    key: 'furniture_name', label: 'Furniture',
                },
                {
                    key: 'bts_name', label: 'BTS',
                },
                {
                    key: 'mrt_name', label: 'MRT',
                },
                {
                    key: 'zone_name', label: 'Zone',
                },
                {
                    key: 'id', label: 'ID',
                },
            ],
            propertyList:[],
            propertyfilter: null,
            ownerfilter: null,
            unit: null,
            floor: null,
            building: null,
            bedroom: null,
            sqm: null,
            price_rent: null,
            price_sale: null,
            totalRow: 0,
            perpage: 15,
            currentPage: 1,
        }
    },
    computed: {
        currentLocale() {
            return  this.$i18n.locale;
        },
    },
    filters: {
        getcomma: function(text){
            if(!text){
                return ''

            }
            var nStr = text;
            nStr += '';
            var x = nStr.split('.');
            var x1 = x[0];
            var x2 = x.length > 1 ? '.' + x[1] : '';
            var rgx = /(\d+)(\d{3})/;
            while (rgx.test(x1)) {
                x1 = x1.replace(rgx, '$1' + ',' + '$2');
            }
            return x1 ;
        },
    },
    methods: {
        selectProperty(item) {
            const index =  this.selectedProperties.findIndex(p => p.id === item.id);
            
            if(index <  0){
                this.selectedProperties.push(item);
                this.totalRowSelected = this.selectedProperties.length;
            }
        },
        removeProperty(id) {
            this.selectedProperties = this.selectedProperties.filter(v => v.id  != id);
            this.totalRowSelected = this.selectedProperties.length;
        },
        async getPropertyData() {
            try {
                const offset =  this.perpage * (this.currentPage - 1);
            
                const body = {
                    perpage: this.perpage,
                    offset: offset,
                    is_active: 1,
                    propertyfilter: this.propertyfilter,
                    ownerfilter: this.ownerfilter,
                    unit: this.unit,
                    sqm: this.sqm,
                    building: this.building,
                    bedroom: this.bedroom,
                    floor: this.floor,
                    price_rent: this.price_rent,
                    price_sale: this.price_sale,
                }

                const response = await axios.post('cache-master/v1/property-filter', body);
                console.log('rrresponse', response)
                if(response?.data?.success){
                    this.propertyList = response?.data?.data
                    this.totalRow = response?.data?.total
                }
            } catch(error) {
                console.log('error fetching property data: ', error || 'Cannot fetching property data')
            }
        },
        async getExistingCRMProperty() {
            const getData = await axios.post(`/crm/v1/property-group`, {
                id: this.id
            })

            console.log('getdata', getData?.data?.data[0].properties)
            const data = getData?.data?.data?.[0];
            console.log('dd', data)
            this.selectedProperttIds = []
            this.selectedProperttIds = Array.isArray(data?.properties)
                ? data.properties
                : [];
            this.title = data.title

            console.log('zz', this.selectedProperttIds)
            await this.filterSelectedProperty(this.selectedProperttIds)
        },
        async filterSelectedProperty(selectedIds) {
            console.log('ff', selectedIds)
            try {
                const requests = selectedIds.map(id => {
                    console.log('idd', id)
                    return axios.post('cache-master/v1/property-filter', {
                        perpage: 1,
                        offset: 0,
                        keyword: id
                    });
                });
                console.log('oo', requests)
                const results = await Promise.allSettled(requests);
                console.log('re', results)
                results.forEach((result, index) => {
                    if (result.status === 'fulfilled') {
                        const property = result.value?.data?.data?.[0];
                        console.log('pp', property)
                        if (property) {
                            const exists = this.selectedProperties.some(p => p == property.id);
                            console.log('ex', exists)
                            if (!exists) {
                                this.selectedProperties.push(property);
                            }
                        }
                    } else {
                        console.error(`Error fetching property with ID ${selectedIds[index]}:`, result.reason);
                    }
                });

                console.log('Final selected properties:', this.selectedProperties);
            } catch (err) {
                console.error('Unexpected error:', err);
            }
        },
        async addProperty(item){
            let index =  this.selectedProperties.findIndex(p => p.id === item.id);
            if(index <  0){
                this.selectedProperties.push(item);
                // this.totalpsRows = this.selectedProperties.length;
            }
        },
        async onSubmit(validate) {
            const isValid = await validate();
            const userData = JSON.parse(localStorage.getItem('userData'))

            // if (isValid) {
            //     console.log({
            //         title: this.title,
            //         updated_by: userData.id,
            //         properties: this.selectedProperties
            //     })
            // }
            if (isValid) {
                const response = await axios.post('/crm/v1/property-group/update', {
                    id: this.id,
                    title: this.title,
                    updated_by: userData.id,
                    properties: this.selectedProperties
                });

                if(!response.data.success){
                    this.makeToast('danger','Error 403',res.data.message);
                } else {
                    this.$router.push('/crm/property', () => {
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-right',
                            props: {
                                title: `Done`,
                                icon: 'CoffeeIcon',
                                variant: 'success',
                                text: `You have successfully created.`,
                            },
                        })
                    });
                }
            } else {
                console.log('hih')
            }
        },
    },
    created(){
        this.getExistingCRMProperty()
        this.getPropertyData()
    },
    watch: {
        currentPage(value) {
            this.propertyList = [];
            this.currentPage = value;
            this.getPropertyData();
        },
        propertyfilter(value) {
            this.propertyList = [];
            this.currentPage = 1;
            this.propertyfilter = value;
            this.getPropertyData();
        },
        ownerfilter(value){
            this.propertyList = [];
            this.currentPage = 1
            this.ownerfilter = value;
            this.getPropertyData();
        },
        unit(value){
            this.propertyList = [];
            this.currentPage = 1
            this.unit = value;
            this.getPropertyData();
        },
        sqm(value){
            this.propertyList = [];
            this.currentPage = 1
            this.sqm = value;
            this.getPropertyData();
        },
        building(value){
            this.propertyList = [];
            this.building = value;
            this.currentPage = 1
            this.getPropertyData();
        },
        bedroom(value){
            this.propertyList = [];
            this.currentPage = 1
            this.bedroom = value;
            this.getPropertyData();
        },
        floor(value){
            this.propertyList = [];
            this.floor = value;
            this.currentPage = 1
            this.getPropertyData();
        },
        price_rent(value){
            this.propertyList = [];
            this.currentPage = 1
            this.price_rent = value;
            this.getPropertyData();
        },
        price_sale(value){
            this.propertyList = [];
            this.currentPage = 1
            this.price_sale = value;
            this.getPropertyData();
        },
    },
}
</script>